import { Theme, css } from '@emotion/react';

export const dynamicContentCardAccentuateStyles = ({ colors }: Theme) => css`
  border-top: 4px solid ${colors.borderPrimaryBase};
`;

export const dynamicContentCardErrorStyles = ({ colors }: Theme) => css`
  border-color: ${colors.borderDangerBase};
`;

export const dynamicContentCardHeaderStyles = ({ colors, spacing }: Theme) => css`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${colors.borderDefault};
  padding: ${spacing(2)}px;
  gap: ${spacing(1.5)}px;
`;

export const dynamicContentCardHeaderTextStyles = css`
  flex: 1;
`;

export const dynamicContentCardTitleStyles = ({ spacing }: Theme) => css`
  display: flex;
  gap: ${spacing(1)}px;
`;

export const dynamicContentCardTabsStyles = ({ spacing }: Theme) => css`
  padding: 0 ${spacing(2)}px;
`;
